var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.5222V1.475C20 0.661111 19.3389 0 18.525 0H1.47778C0.661111 0 0 0.661111 0 1.475V18.5222C0 19.3389 0.661111 20 1.47778 20H18.5222C19.3389 20 20 19.3389 20 18.5222ZM3.06942 7.60785H6.07498V17.1606H3.06942V7.60785ZM4.5722 2.83008C5.53053 2.83008 6.30553 3.56063 6.30553 4.55785C6.30553 5.55508 5.53053 6.28285 4.5722 6.28285C3.61387 6.28285 2.83887 5.55508 2.83887 4.55785C2.83887 3.56063 3.61387 2.83008 4.5722 2.83008ZM13.6694 7.34674C15.3472 7.34674 17.1611 8.34397 17.1611 11.2606H17.1583V17.1662H14.1528V11.9495C14.1528 10.4106 13.5 9.93563 12.6555 9.93563C11.7639 9.93563 10.8889 10.6078 10.8889 11.9884V17.1662H7.88331V7.61619H10.7722V8.93841H10.8111C11.1028 8.34952 12.1194 7.34674 13.6694 7.34674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.f68b357155d8042edf5a22c745959cc6.svg";
export { ForwardRef as ReactComponent };